export const REFERENCE_FORM_NAME = 'reference';



// WEBPACK FOOTER //
// ./src/modules/ReferenceForm/constants.js